import React from 'react'
import Sidebar from '../../Component/Sidebar/Sidebar'
import Header from '../../Component/Header/Header'
import DeletedProjectsContent from '../../Component/DeletedProjects/DeletedProjectsContent'

function DeletedInvoice() {
  return (
    <div className="apDiv Roles">
      <Sidebar />
      <div className="body_container container" dir="rtl">
        <div className="Header">
          <Header />
        </div>
        <DeletedProjectsContent />
      </div>
    </div>
  )
}

export default DeletedInvoice
